<template>
  <div class="comp-qf-body-summary-cell" :class="{ disabled: notSupported }">
    <div class="not-supported" v-if="notSupported">
      <qf-ellipsis :content="$t('不支持汇总')">
        <span class="not-supported-text">
          {{ $t('不支持汇总') }}
        </span>
      </qf-ellipsis>
    </div>
    <jw-dropdown v-else class="aggregation-dropdown" position="top" @select="aggregationTypeChange">
      <div class="cell-wrapper">
        <div v-if="aggregation === aggregationTypes.none.value" class="none-placeholder">
          <qf-ellipsis :content="$t('数据汇总')">
            <span class="hand none-placeholder-text">
              <qfei-icon-down-outlined />
              {{ $t('数据汇总') }}
            </span>
          </qf-ellipsis>
        </div>
        <qfei-icon-refresh-outlined v-else-if="value === summaryStatus.loading" spin class="primary-icon" />
        <div v-else-if="value === summaryStatus.error" class="hand">-</div>
        <div v-else-if="value != null" class="aggregation-result hand">
          <qf-ellipsis :content="formatedValue">
            <span class="label">{{ aggregationTypes[aggregation]?.label }}:&nbsp;</span>
            <span class="value"> {{ formatedValue }} </span>
          </qf-ellipsis>
        </div>
      </div>
      <template #content>
        <jw-doption v-for="item of aggregationTypeListWithNone" :key="item.value" :value="item.value">
          <div class="aggregation-type-option">
            {{ item.label }}
            <qfei-icon-generate-outlined v-if="item.value === aggregation" class="primary-icon" />
          </div>
        </jw-doption>
      </template>
    </jw-dropdown>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { aggregationTypes, summaryStatus } from '../contants';
import QfEllipsis from '@/components/table/qf-ellipsis/qf-ellipsis.vue';
import { getAggregationList } from '../utils';

const props = defineProps({
  column: Object,
  aggregationType: String,
  notSupported: {
    type: Boolean,
    default: false
  },
  value: {},
  formatter: Function
});

const emits = defineEmits(['change']);

const fieldKey = computed(() => props.column.colKey);

const aggregationTypeList = computed(() => {
  const { fieldType, fieldExt } = props.column;
  return getAggregationList(fieldType, fieldExt);
});

const aggregationTypeListWithNone = computed(() => {
  return aggregationTypeList.value?.concat(aggregationTypes.none);
});

const aggregation = computed(() => {
  if (aggregationTypeListWithNone.value?.every((item) => item.value !== props.aggregationType)) {
    // 未在前端定义的统计类型视为none
    return aggregationTypes.none.value;
  } else {
    return props.aggregationType;
  }
});

const notSupported = computed(() => {
  return props.notSupported || !aggregationTypeListWithNone.value;
});

const aggregationTypeChange = (type) => {
  if (type === aggregation.value) return;
  emits('change', { fieldKey: fieldKey.value, type });
};

const formatedValue = computed(() => {
  const { fieldType, fieldExt } = props.column;
  const value = props.value;
  return props.formatter?.(fieldType, fieldExt, value) || value;
});
</script>
<style scoped lang="less">
@import 'qf-body-summary-cell.less';
</style>
